<template>
    <div class="shop-banner-slide">
        <div class="swiper-container">
            <div class="swiper-wrapper">
                <slot />
            </div>
        </div>
        <div class="swiper-control">
            <div class="swiper-prev"><v-icon>mdi-chevron-left</v-icon></div>
            <div class="swiper-next"><v-icon>mdi-chevron-right</v-icon></div>
        </div>
    </div>
</template>

<script>

export default {
    mounted(){
        this.$nextTick(() => {
            this.banner = new window.Swiper('.shop-banner-slide .swiper-container', {
                slidesPerView: 1,
                spaceBetween: 14,
                autoplay: {
                    delay: 3000,
                    disableOnInteraction: false,
                },
                speed: 500,
                loop: true,
                navigation: {
                    nextEl: ".shop-banner-slide .swiper-next",
                    prevEl: ".shop-banner-slide .swiper-prev",
                },
            })
        })
    },
}
</script>

<style lang="scss" scoped>
.shop-banner-slide{
    position: relative;
    .swiper-prev, .swiper-next {
        color: #424242;
        background-color: #e6e6e6;
        width: 24px;
        height: 24px;
        .v-icon{
            font-size: 16px;
        }
    }
    .swiper-prev{
        left: 6px;
    }
    .swiper-next{
        right: 6px;
    }
}
.shop-banner{
    display: block;
    position: relative;
    width: 100%;
    height: 0;
    padding-top: calc((200 / 1100) * 100%);
    &__inner{
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
    }
}
@media (min-width:576px){
}
@media (min-width:768px){
    .shop-banner-slide{
        .swiper-prev, .swiper-next {
            width: 30px;
            height: 30px;
            .v-icon{
                font-size: 20px;
            }
        }
        .swiper-prev{
            left: 12px;
        }
        .swiper-next{
            right: 12px;
        }
    }
}
@media (min-width:1024px){
}
@media (min-width:1200px){
}

</style>